import React, { forwardRef } from 'react';
import DefaultButton from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/core/migration/chevron-down';
import { PaginatedPickerIntlProvider } from '../../../common/utils';
import { ClearButton } from './clear-button';
import { LoadingStateAnimationWrapper } from './loading-state';
import { ButtonWrapper, ChildrenWrapper, StyledChevron, StyledClose } from './styled';
export var PickerTrigger = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    isInvalid = _ref.isInvalid,
    isSelected = _ref.isSelected,
    triggerIcon = _ref.triggerIcon,
    isLoading = _ref.isLoading,
    hasValues = _ref.hasValues,
    onClick = _ref.onClick,
    onClear = _ref.onClear,
    testId = _ref.testId,
    isDisabled = _ref.isDisabled;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(PaginatedPickerIntlProvider, null, /*#__PURE__*/React.createElement(LoadingStateAnimationWrapper, null, /*#__PURE__*/React.createElement(DefaultButton, {
      isSelected: true,
      iconBefore: triggerIcon,
      testId: testId
    }, children, ":")));
  }
  // TODO : fix spacing.. this is overlapping with the Chevron
  var iconAfter = /*#__PURE__*/React.createElement(ClearButton, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClear === null || onClear === void 0 || onClear();
    },
    label: "Remove criteria"
  });
  var Content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChildrenWrapper, null, children), onClear ? /*#__PURE__*/React.createElement(StyledClose, null, iconAfter) : /*#__PURE__*/React.createElement(StyledChevron, null, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    color: "currentColor",
    label: "",
    LEGACY_margin: "-5px 0 0 0",
    size: "small"
  })));
  return /*#__PURE__*/React.createElement(PaginatedPickerIntlProvider, null, /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(DefaultButton, {
    appearance: isInvalid ? 'danger' : 'default',
    isSelected: isSelected || hasValues,
    iconBefore: triggerIcon,
    onClick: onClick,
    ref: ref,
    testId: testId,
    "aria-expanded": isSelected,
    isDisabled: isDisabled
  }, Content)));
});
export default PickerTrigger;